import { EndingType } from '../types';

export interface EndingData {
  title: string;
  subtitle: string;
  text: string[];
  condition: string;
}

export const ENDINGS: Record<EndingType, EndingData> = {
  ending_a: {
    title: 'END A ― 逃避',
    subtitle: '目を閉じたまま',
    text: [
      'あなたは答えた。',
      'だが、その言葉に実感はなかった。',
      '',
      'この校舎で何があったのか。',
      '詩織が何を感じていたのか。',
      'あなたは本当に理解しているのだろうか。',
      '',
      '「……あなたは、まだ何も見ていない」',
      '',
      '詩織の声が遠ざかる。',
      '校舎が暗闇に沈んでいく。',
      '',
      '……あなたは再び、教室で目を覚ます。',
      '',
      '何度でも。何度でも。',
      '真実から目を逸らし続ける限り。',
      '',
      '「……もっと、ちゃんと見て」',
      '',
      '背後から、微かな声が聞こえた。',
    ],
    condition: '探索率60%未満',
  },

  ending_b: {
    title: 'END B ― 向き合う',
    subtitle: '不完全な贖罪',
    text: [
      'あなたは詩織に向き合った。',
      '自分の中にある言葉を、精一杯伝えた。',
      '',
      '風が止み、月明かりが強くなる。',
      '',
      '「……ありがとう。あなたの気持ちは伝わった」',
      '',
      '詩織の姿が薄くなっていく。',
      '',
      '「でも、まだ足りない。',
      '　あなたはこの校舎のすべてを見ていない。',
      '　私が過ごした場所を、もっと知ってほしかった」',
      '',
      '校舎が崩れ始める。',
      'あなたは出口に向かって走る。',
      '',
      '外に出ると、そこは見知らぬ街だった。',
      '朝日が眩しい。',
      '',
      '……ポケットの中に、古い写真が一枚ある。',
      '笑顔の中、一人だけ俯いている少女。',
      '',
      '罪悪感は消えない。',
      'でも、もう目を逸らさない。',
    ],
    condition: '探索率60%以上',
  },

  ending_c: {
    title: 'END C ― 真の脱出',
    subtitle: 'あなたの声が届いた日',
    text: [
      '「君のことを、忘れない」',
      '',
      'あなたは詩織の目をまっすぐ見て言った。',
      '',
      '「これからは、見て見ぬふりをしない。',
      '　誰かが苦しんでいたら、声をかける。',
      '　それが、君に対する自分の答えだ」',
      '',
      '詩織は微笑んだ。',
      '初めて見る、穏やかな笑顔だった。',
      '',
      '「……ずっと、その言葉を待ってた」',
      '',
      '風が優しく吹く。',
      '詩織の姿が光に包まれていく。',
      '',
      '「ねえ、最後にひとつだけ」',
      '',
      '「私の日記、全部読んでくれたんだね。',
      '　私のこと、ちゃんと知ろうとしてくれたんだね。',
      '　……嬉しかった」',
      '',
      '光が消えると、校舎も消えていた。',
      'あなたは自分の部屋のベッドの上にいる。',
      '',
      '朝日が差し込む。新しい一日が始まる。',
      '',
      '机の上に一通の手紙がある。',
      '昨夜までなかったはずの、古い封筒。',
      '',
      '「ありがとう。さようなら。',
      '　　　　　　　　水無月 詩織」',
      '',
      '……窓の外で、ピアノの旋律が微かに聞こえた気がした。',
    ],
    condition: '探索率80%以上 + 日記5つ全収集',
  },
};
